<div class="slider-back" [hidden]="!showShadow">

</div>

<div [hidden]="!showShadow">
    <div class="slider" [ngClass]="{'shadow' : showShadow === true}" [@slideInOut]="animationState">
        <div class="tab-header">Create/Edit Utility
            <div class="btn-close-position" (click)="changeState(2)">
                <div class="btn-close">
                    <img src="assets/images/icons/Close.png">
                </div>
            </div>

        </div>
        <div class="conent">
            <form (submit)="f.valid" class="form col-sm-12" #f="ngForm">
                <label class="labelPopup">Utility name</label>
                <input class="form-control" name="name" [(ngModel)]="selectedUtility.name" #name="ngModel" required
                    autocomplete="off" placeholder="Utility name"/>
                <div *ngIf="f.submitted && name.invalid" class="form-control-error">Utility name is required</div>
                <br>
                <label class="labelPopup">Microsoft Entra Client Id</label>
                <input class="form-control" name="entraClientId" [(ngModel)]="selectedUtility.entraClientId" #entraClientId="ngModel" 
                    autocomplete="off" placeholder="Microsoft Entra Client Id"/>
                <br>
                <label class="labelPopup">Microsoft Entra Tenant Id</label>
                <input class="form-control" name="entraTenantId" [(ngModel)]="selectedUtility.entraTenantId" #entraClientId="ngModel" 
                    autocomplete="off" placeholder="Microsoft Entra Tenant Id"/>
                <br>
                <label class="labelPopup">Use Microsoft Login</label>
                <div class="utility-item-area">
                    <div (click)="useMicrosoftLogin()">
                        <div class="switch-wrapper" [ngClass]="{'selected' : selectedUtility.isEntraEnabled}">
                            <div class="switch"></div>
                        </div>
                    </div>
                </div>
                <div class="urlDiv">
                    <div class="d-flex align-items-center">
                        <label class="labelPopup">Connected Applications</label>
                        <button class="action-btn col-xs-6" (click)="addApp()">+</button>
                    </div>
                    <div *ngFor="let item of selectedUtility.applications;  let i=index; trackBy: trackByFn">
                        <div class="d-flex" style="flex-direction: column;">
                            <label>{{ item.applicationName }}</label>
                            <div class="d-flex">
                                <input type="text" class="form-control" name="applications{{i}}" [(ngModel)]="selectedUtility.applications[i].domain"
                                    #applications="ngModel" id="applications{{i}}"
                                        autocomplete="off"/>
                                
                                <div class="button-url">
                                    <button class="btn" (click)="$event.stopPropagation(); deleteApplication(i)">
                                        <img src="assets/images/icons/CloseWhite.png" alt="Remove icon">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="connectWithApp" class="row m-0">
                    <label class="col-12 mt-2 p-0">Connect utility with the applicaion</label>
                    <div class="col-12 p-0 d-flex">
                        <div class="col-4 pl-0">
                            <span>Application</span>
                            <select [(ngModel)]="selectedNewAppValue" name="appSelect" class="form-control">
                                <option *ngFor="let app of applications" [value]="app.value">
                                    {{ app.name }}
                                </option>
                            </select>                        
                        </div>
                        <div class="col-8 pr-0">
                            <span>Domain</span>
                            <input type="text" class="form-control" [(ngModel)]="newDomain" name="domainInput">
                        </div>
                    </div>
                    <button (click)="saveApp()" class="action-btn mt-2 ml-0">Add</button>
                </div>
                <br>
            </form>
        </div>
        <div class="sticky user-btn">
            <button class="submit col-xs-6" [disabled]="!f.valid" (click)="save()">Save</button>
            <button class="cancel-btn col-xs-6" (click)="changeState(2)">Cancel</button>
        </div>
    </div>
</div>